import * as React from 'react';
import styled from 'styled-components';
import LazyImage from 'components/Image/LazyImage';
import noImage from './noIMG.svg';
import media from 'utils/mediaStyle';

export const ImageWrapper = styled.div<any>`
  width: 106px;
  height: 106px;
  background: #ffffff;
  overflow: hidden;
  ${({ size }) =>
    size &&
    `
    width: ${size}px;
    height: ${size}px;
  `}
  ${({ zoomIn }) =>
    zoomIn
      ? `
  img {
    transition: transform 0.3s ease-out;
    transform: scale(1, 1, 1);
    &:hover {
      transform: scale3d(1.2, 1.2, 1.2);
    }
  }
  `
      : ``};
`;

export const RImage = styled(({ noImage, ...rest }) => <LazyImage {...rest} />)<any>`
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  left: 0;
  object-fit: ${({ noImage }) => (noImage ? 'contain' : 'cover')};
  ${({ noImage }) => (noImage ? `opacity: 0.3;` : '')};
  border-radius: 10px;
  border: 1px solid #eaeaeb;
  ${({ noBorder }) =>
    noBorder &&
    `
    border-radius: 0px !important;
    border: none !important;
  `}
  ${media.md`
    // padding: 8px;
  `};
`;

export interface ImageProps {
  src?: string;
  alt: string;
  zoomIn?: boolean;
  size?: number;
  noBorder?: boolean;
}

export const Image = ({ src, alt, zoomIn, size, noBorder }: ImageProps) => (
  <ImageWrapper zoomIn={zoomIn} size={size}>
    <RImage noBorder={noBorder} noImage={!src} src={src || noImage} alt={alt} />
  </ImageWrapper>
);
